<template>
    <v-layout align-center column>


<img src="../../assets/EmailSuccess/Success-Illustration.png"
     srcset="../../assets/EmailSuccess/Success-Illustration@2x.png 2x,
             ../../assets/EmailSuccess/Success-Illustration@3x.png 3x"
     class="Success-Illustration">
<p class="Selamat-Verifikasi-Email-Anda-Sukses">Selamat, Verifikasi Email Anda Sukses!</p>
<p class="Silahkan-melanjutkan-proses-registrasi-dengan-mema">Silahkan melanjutkan proses registrasi dengan memastikan verifikasi nomor handphone telah dilakukan. Proses transaksi Anda dapat dilanjutkan melalui login di Aplikasi DompetKilat.

Apabila Anda menemukan kesulitan, silahkan hubungi kami di <span class="text-style-1">cs@dompetkilat.co.id</span></p>

<a href="/"> <div class="Shape"><p class="Shape-Text">Go To Homepage</p></div></a>
    </v-layout>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.Success-Illustration {
  width: 400px;
  height: 400px;
  flex-grow: 0;
  margin: 0 171px 22px;
  object-fit: contain;
}
.Selamat-Verifikasi-Email-Anda-Sukses {
  width: 478px;
  height: 30px;
  flex-grow: 0;
  margin: 22px 132px 16px;
  font-family: Sora;
  font-size: 24px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #d3352c;
}
.Silahkan-melanjutkan-proses-registrasi-dengan-mema {
  width: 742px;
  height: 88px;
  flex-grow: 0;
  margin: 16px 0 44px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}

.Silahkan-melanjutkan-proses-registrasi-dengan-mema .text-style-1 {
  font-weight: bold;
  color: #d3352c;
}
.Shape {
  width: 225px;
  height: 48px;
  flex-grow: 0;
  /* margin: 44px 258px 0 259px; */
  padding: 15px 54px 16px;
  border-radius: 26px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #252525;
}
.Shape-Text {
  width: 117px;
  height: 17px;
  flex-grow: 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
</style>